export const ASIDE_WIDTH = 240;
export const HEADER_HEIGHT = 80;
export const ASIDE_ITEM_HEIGHT = 56;
export const DEFAULT_ASIDE_WIDTH = 64;
export const ASIDE_MIN_WIDTH = 72;

export const MESSAGE_SUCCESS = 'Success';
